/*форма запису data-yam-popup="#id"*/
/*Скрипт піднімає вибрану popup форму*/
if ($('[data-yam-popup]').length) {
    $('[data-yam-popup]').on('click', function () {
        $.fancybox.open($($(this).attr('data-yam-popup')));
    });
}


// WEBPACK FOOTER //
// ./libs/data-yam-popup.js